import * as React from 'react';
import ReportSummary from '../../Components/ReportSummary';
import { EReport } from '../../Actions/Report/Actions';

const BreakBulk = () => (<ReportSummary section="Embarcado Break Bulk" report={EReport.BreakBulk} />);

export default BreakBulk;
